import type { ManageEvent } from '../manage-events.slice'

export let statusDisplayLabel = (
  s: ManageEvent['registrationStatus'],
): string =>
  s === 'registration-open'
    ? 'Registration open'
    : s === 'registration-closed'
      ? 'Registration closed'
      : 'Unscheduled'
